import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const API_URL = process.env.REACT_APP_ENDPOINT; 

export const fetchUser = createAsyncThunk(
    'user/list', 
    async (_, { getState, rejectWithValue }) => {
        try {
            const token = getState().auth.token || localStorage.getItem('authToken');

            const response = await axios.get(`${API_URL}/user/list`, {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
            });
            
            return response.data.data;
        } catch (error) {
            console.error('Error fetching users:', error);
            return rejectWithValue(error.response?.data || 'Failed to fetch items');
        }
    }
);

export const createUser = createAsyncThunk(
    'user/store', 
    async (item, { getState, rejectWithValue }) => {
        try {
            const token = getState().auth.token || localStorage.getItem('authToken');
            
            const response = await axios.post(`${API_URL}/user/store`, item, {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
            });

            return response.data; 
        } catch (error) {
            return rejectWithValue(error.response?.data || 'Failed to create item');
        }
    }
);

export const updateUser = createAsyncThunk(
    'user/update', 
    async (item, { getState, rejectWithValue }) => {        
        try {
          const token = getState().auth.token || localStorage.getItem('authToken');
          const response = await axios.put(`${API_URL}/user/update/${item.id}`, item, {
              headers: {
                Authorization: `Bearer ${token}`,
              },
          });
          
          return response.data;
      } catch (error) {
          return rejectWithValue(error.response?.data || 'Failed to update item');
      }
    }
);

export const deleteUser = createAsyncThunk(
    'user/delete', 
    async (id, { getState, rejectWithValue }) => {
        try {
            const token = getState().auth.token || localStorage.getItem('authToken');
            await axios.delete(`${API_URL}/user/delete/${id}`, {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
            });

            return id;
        } catch (error) {
            return rejectWithValue(error.response?.data || 'Failed to delete item');
        }
    }
);

const userSlice = createSlice({
    name: 'users',
    initialState: {
        users: [],
        isLoading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchUser.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(fetchUser.fulfilled, (state, action) => {
                state.isLoading = false;
                state.users = action.payload;
            })
            .addCase(fetchUser.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            })
            .addCase(createUser.fulfilled, (state, action) => {
                state.users.push(action.payload.data);
            })
            .addCase(updateUser.fulfilled, (state, action) => {
                const index = state.users.findIndex((item) => item.id === action.payload.data.id);
                console.log(index);
                
                if (index !== -1) {
                    state.users[index] = { ...state.users[index], ...action.payload.data };
                }
                state.isLoading = false;
            })
            .addCase(deleteUser.fulfilled, (state, action) => {
                state.users = state.users.filter((item) => item.id !== action.payload);
            });
    },
});

export default userSlice.reducer;
